import { EFeedbackFormActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const enableLoadForm = actionGenerator(EFeedbackFormActionType.LoadFormEnabled);
